function formatBrowser(name: string, version: string | number = 'unknown'): Maybe<string> {
  return `Browser: ${name}, version ${version}` || null;
}

export function whichBrowser(): Maybe<string> {
  const {navigator} = window;
  const {userAgent} = navigator;

  let regMatches: RegExpExecArray | RegExpMatchArray | [];
  let uaMatches =
    userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(uaMatches[1])) {
    regMatches = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return formatBrowser('Explorer', regMatches[1]);
  }

  if (uaMatches[1] === 'Chrome') {
    regMatches = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
    if (regMatches !== null) {
      const app = regMatches.slice(1).toString().split(',');
      return formatBrowser(app[0].replace('OPR', 'Opera'), app[1]);
    }
  }

  uaMatches = uaMatches[2]
    ? [uaMatches[1], uaMatches[2]]
    : [navigator.appName, navigator.appVersion, '-?'];

  regMatches = userAgent.match(/version\/(\d+)/i);
  if (regMatches !== null) {
    uaMatches.splice(1, 1, regMatches[1]);
  }

  return formatBrowser(uaMatches[0], uaMatches[1]);
}
